import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  console.log("Token:", token);
  const [config, setConfig] = useState(null);
  const [verifying, setVerifying] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch(() => setMessage("Failed to load config."));
  }, []);


  useEffect(() => {
    if (!config || !token) return;

    const verifyToken = async () => {
      setVerifying(true);
      try {
        const res = await fetch(
          `${config.BASE_URL}${config.VERIFY_TOKEN}?token=${token}`
        );
        const data = await res.json();
        if (data.status) {
          setTokenValid(true);
        } else {
          setMessage(data.message || "Invalid or expired token.");
        }
      } catch (err) {
        setMessage("Server error while verifying token.");
      } finally {
        setVerifying(false);
      }
    };

    verifyToken();
  }, [config, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!password || !confirmPassword) {
      setMessage("Please fill in both fields.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${config.BASE_URL}${config.UPDATE_PASSWORD}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (data.status) {
        setMessage("Password updated successfully! Redirecting to login...");
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setMessage(data.message || "Failed to update password.");
      }
    } catch (err) {
      setMessage("Server error while updating password.");
    } finally {
      setLoading(false);
    }
  };

  if (!config) return <p>Loading config...</p>;
  if (verifying) return <p>Verifying token...</p>;
  if (!tokenValid)
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <h2 style={{ color: "red" }}>
        {message || "This reset link is invalid or expired."}
      </h2>
    </div>
  );


  return (
    <div style={{ maxWidth: "400px", margin: "auto", marginTop: "50px" }}>
      <h2>Set New Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
        />
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
        />
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "8px",
            backgroundColor: "green",
            color: "white",
            border: "none",
          }}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
      {message && <p style={{ marginTop: "15px", color: "#555" }}>{message}</p>}
    </div>
  );
};

export default ResetPasswordForm;
